import { addMonths } from 'date-fns';

import getDateMonthAndYear from './getDateMonthAndYear';
import { Month } from '../types';

export default function getNextMonths(
  months: Month[],
  numberOfMonths: number,
  counter: number,
  step: number,
): Month[] {
  let prevMonth;

  const ascending = counter > 0;

  if (step) {
    prevMonth = ascending ? 0 : months.length - step;
  } else {
    prevMonth = ascending ? months.length - 1 : 0;
  }

  let prevMonthDate = months[prevMonth].date;

  return Array.from(Array(numberOfMonths)).reduce<Month[]>((m) => {
    if (m.length === 0) {
      prevMonthDate = addMonths(prevMonthDate, counter);
    } else {
      prevMonthDate = addMonths(prevMonthDate, counter >= 0 ? 1 : -1);
    }

    return ascending
      ? m.concat([getDateMonthAndYear(prevMonthDate)])
      : [getDateMonthAndYear(prevMonthDate)].concat(m);
  }, []);
}
